import React from "react"
import { BoxWrapper } from "components"

const CaseStudies = ({ boxWrapperProps }: ICaseStudiesContainerProps) => {
  return <BoxWrapper {...boxWrapperProps}></BoxWrapper>
}

export default CaseStudies
